import React from "react";
import { IContent, IPMBlock } from "../../../models/IPages";
import FormSelect from "../../../components/UI/formSelect/formSelect";
import Input from "../../../components/UI/input/GgInput";
import FileButton from "../../../components/UI/button/FileButton";
import { AddIcon } from "../../../assets/icons";
import { getImageExtensionFromBase64 } from "../../../utils";

function FifthBlock({ data, setData, articles, categoryType, actionData }: IPMBlock) {
  const handleFifthBlock = (index: number, val: string, type: keyof IContent) =>
    setData((prev: any) => {
      const newContent = [...prev.content];
      newContent[index][type] = val;
      if (type === "image") {
        const newImages = prev.images || [];
        newImages[index] = val;
        const ext = getImageExtensionFromBase64(val);
        newContent[index][
          "image"
        ] = `/image/page-management/${categoryType}/fifthBlock${index + 1}.${
          ext || "jpeg"
        }`;
        return { ...prev, images: newImages, content: newContent };
      }
      return { ...prev, content: newContent };
    });

  return (
    <>
      <div className="title">Fifth Block</div>
      <div className="step-list col">
        <div className="step-list">
          <div className="step-item">
            <div className="step-title">Title</div>
            <div className="inputs-container">
              <Input
                type="text"
                placeholder="Enter title"
                value={data?.title}
                onChange={(val) => setData({ ...data, title: val })}
                disabled={!actionData?.edit}
              />
            </div>
          </div>
          <div className="step-item">
            <div className="step-title">Subtitle</div>
            <div className="inputs-container">
              <Input
                type="text"
                placeholder="Enter subtitle"
                value={data?.subtitle}
                onChange={(val) => setData({ ...data, subtitle: val })}
                disabled={!actionData?.edit}
              />
            </div>
          </div>
        </div>
        <div className="card-container">
          {[1, 2, 3].map((item: any, index: any) => {
            return (
              <div key={index} className="card">
                <FileButton
                  index={"fifth" + index}
                  icon={{
                    leftIcon: <AddIcon size="18" className="icon" />,
                  }}
                  value={data?.content[index].image}
                  stylesType="border"
                  onChange={(val) => handleFifthBlock(index, val, "image")}
                  className="cover-image-button"
                  disabled={!actionData?.edit}
                />
                <Input
                  type="text"
                  placeholder="Enter title"
                  value={data?.content[index].heading}
                  onChange={(val) => handleFifthBlock(index, val, "heading")}
                  disabled={!actionData?.edit}
                />
                <Input
                  type="text"
                  placeholder="Enter description"
                  value={data?.content[index].description}
                  onChange={(val) =>
                    handleFifthBlock(index, val, "description")
                  }
                  disabled={!actionData?.edit}
                />
                <Input
                  type="text"
                  placeholder="Enter link"
                  value={data?.content[index].link}
                  onChange={(val) => handleFifthBlock(index, val, "link")}
                  disabled={!actionData?.edit}
                />
                {/* <FormSelect
                  list={articles}
                  defaultValue={data?.content[index].link}
                  label="Page link"
                  onChange={(val) => handleFifthBlock(index, val.value, "link")}
                /> */}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default FifthBlock;
